<sdds-theme name="scania"></sdds-theme>

<app-header></app-header>

@if (showLandingPage) {
<div>
  <app-error></app-error>
</div>

<app-footer></app-footer>
}
